import React from 'react'
import './LinkCard.scss'

const CTA = ({ href = '', target = '', className = null, children }) => {
  return (
    <a href={href} target={target} className={className}>
      {children}
    </a>
  )
}

const LinkCard = ({ card }) => {
  const { eyebrow, title, body, imageId, buttonCopy, url } = card

  return (
    <div className="root">
      <img className="img" src={`${process.env.SITE_ASSET_URL}/${imageId}`} />
      <div className="positioner">
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        {title && (
          <div tag="h3" className="title">
            {title}
          </div>
        )}
        {body && (
          <div tag="p" className="subtitle">
            {body}
          </div>
        )}
        {buttonCopy && (
          <CTA href={url} className="cta">
            {buttonCopy}
          </CTA>
        )}
      </div>
    </div>
  )
}

export default LinkCard
